webpackJsonp([162802253351699],{

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookActions = __webpack_require__(26);
	
	var _LoreHookActions2 = _interopRequireDefault(_LoreHookActions);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookActions2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'cidBodyAttributeName'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This field let\'s you change the name of the cid field sent to the server when performing optimistic updates through WebSockets. By default the property send to the server is called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'cid'
	      ),
	      ', matching the name of the attribute on the client-side, but you can change if you need to to match the API.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      cidBodyAttributeName: \'cid\'\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-actions-options-cid-body-attribute-name-js-033cd112b0cc241bd90e.js